import {BaseConfig} from "../../infrastructure/config/base-config";
import {TopPerformersWidgetTerms} from "./top-performers-widget.terms";

export class TopPerformersWidgetConfig extends BaseConfig {

  static injectables = [TopPerformersWidgetTerms];

  constructor(terms: TopPerformersWidgetTerms) {
    super('top-performers', null, terms);
  }
}
